<template>
    <div class="h100">
        <div class="flex h100">
            <div class="h100 flex-width mr20 flex-column">
                <div class="flex items-center mt10">
                    <div class="fs12 bold">注册链接</div>
                    <div class="ml10 flex-width">
                        <el-input v-model="registerUrl" placeholder="请输入内容" disabled size="medium"></el-input>
                    </div>
                </div>
                <div class="mt10 flex-height">
                    <el-table :data="showMembers" style="width: 100%" height="100%" size="mini">
                        <el-table-column prop="id" label="ID"></el-table-column>
                        <el-table-column prop="username" label="手机号"></el-table-column>
                        <el-table-column prop="name" label="姓名"></el-table-column>
                        <el-table-column prop="roleName" label="职位"></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h100 flex-column" style="width: 300px; border-left: 1px solid rgba(0,0,0,0.05);">
                <div class="pl20 mt20 bold flex items-center">
                    <div class="fs14">账号组</div>
                    <div class="ml5">
                        <i class="el-icon-circle-plus-outline" @click="dialogVisible=true"></i>
                    </div>
                </div>
                <div class="flex-height scroll">
                    <ul class="fs14 user_group">
                        <li @click="chooseGroup(group)" :class="group.id == selectGroup ? 'active' : ''" v-for="group in groups" :key="group.id">{{group.name}}</li>
                    </ul>
                </div>
            </div>
        </div>

        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%">
            <div>
                <el-input v-model="newGroupName" placeholder="请输入内容"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addGroup">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            groups: [],
            dialogVisible: false,
            newGroupName: "",
            registerUrl: "",
            selectGroup: -1,
            members: []
        }
    },
    computed: {
        showMembers() {
            if (this.selectGroup == -1) {
                return this.members;
            } else {
                return this.members.filter((it) => {
                    return it.role == this.selectGroup;
                })
            }
        }
    },
    async created() {
        await this.getUserGroup();
        this.getRegToken();
        this.getGroupMember();
        // this.registerUrl = "http://127.0.0.1:8080/join/"
    },
    methods: {
        async getGroupMember() {
            let rs = await this.$api.getGroupMember();
            if (rs.err == 0) {
                for (let item of rs.data) {
                    let role = this.groupMap[item.role];
                    item.roleName = role.name;
                }
                this.members = rs.data;
            }
        },
        async getRegToken() {
            let rs = await this.$api.getRegToken();
            if (rs.err == 0) {
                this.registerUrl = `${this.$api.request_body.url.replace('/admin', '')}/join/${rs.data}`;
            }
        },
        async getUserGroup() {
            this.groupMap = {};
            let rs = await this.$api.getUserGroup();
            if (rs.err == 0) {
                this.groups = rs.data;
                for (let item of rs.data) {
                    this.groupMap[item.id] = item;
                }
                this.groups.unshift({
                    id: -1, name: "全部"
                })
            }
        },
        async addGroup() {
            if (this.newGroupName != "") {
                let rs = await this.$api.addUserGroup(this.newGroupName);
                if (rs.err == 0) {
                    this.getUserGroup();
                }
                this.dialogVisible = false;
            }
            
        },
        chooseGroup(group) {
            this.selectGroup = group.id;
        }
    }
}
</script>

<style lang="less" scoped>
.user_group {
    list-style-type: none;
    margin: 0;
    padding-left: 20px;
    padding-top: 10px;

    li {
        height: 30px;
        border: 1px solid rgba(0,0,0,0.05);
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        cursor: pointer;

        &.active {
            background: #67C23A;
            color: white;
        }
    }
}
</style>